import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ResponsiveBreakpointsService {
  responsiveSubject: Subject<any> = new Subject();

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/system/core/responsive-breakpoints/responsive-breakpoints.service.ts